import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Container, PageHeader, Spinner, EmptyState } from "@/components/common";
import { DanceCard } from "@/components/DanceCard";
import { Bookmark } from "lucide-react";

const FILTERS = [{ k: "all", l: "All" }, { k: "favourite", l: "Favourites" }, { k: "learning", l: "Learning" }, { k: "know_it", l: "Know It" }];

export default function MyDances() {
  const [filter, setFilter] = useState("all");
  const { data, isLoading, refetch } = useQuery({ queryKey: ["my-dances", filter], queryFn: async () => (await api.get(`/me/dances?filter=${filter}`)).data });

  return (
    <div>
      <PageHeader eyebrow="My Dances" title="Your personal dance library" subtitle="Everything you've saved, all linking back to the central dance — so tutorials and step sheets stay up to date." />
      <Container className="py-8">
        <div className="mb-6 flex flex-wrap gap-2">
          {FILTERS.map((f) => (
            <button key={f.k} onClick={() => setFilter(f.k)} data-testid={`mydances-filter-${f.k}`}
              className={`rounded-full px-4 py-2 text-sm font-semibold ${filter === f.k ? "bg-[#C85A32] text-white" : "bg-card border border-border text-[#5C4A42]"}`}>{f.l}</button>
          ))}
        </div>
        {isLoading ? <Spinner /> : !data?.length ? (
          <EmptyState title="Nothing saved here yet" subtitle="Browse the Dance Library and tap Favourite, Learning or Know It to build your collection." icon={Bookmark} />
        ) : (
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {data.map((d) => <DanceCard key={d.id} dance={d} onStatusChange={() => refetch()} />)}
          </div>
        )}
      </Container>
    </div>
  );
}
